import { render, staticRenderFns } from "./HomePersonas.vue?vue&type=template&id=d1f4569a&scoped=true&"
import script from "./HomePersonas.vue?vue&type=script&lang=js&"
export * from "./HomePersonas.vue?vue&type=script&lang=js&"
import style0 from "./HomePersonas.vue?vue&type=style&index=0&id=d1f4569a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f4569a",
  null
  
)

export default component.exports